export default "__VITE_ASSET__5ae80be2__"